<template>
  <div>
    <div class="row align-content-center align-items-center">
      <div class="col-md-12">
        <div class="broad-in">
<!--          <ul itemscope="" itemtype="http://schema.org/BreadcrumbList">-->
<!--            <li v-for="(item, i) in breadcrumbList"  itemprop="itemListElement" itemscope="" itemtype="http://schema.org/ListItem">-->
<!--              <span v-if="item.TITLE==='/'">{{item.TITLE}}</span>-->
<!--              <span v-if="item.TITLE!=='/'&&item.LINK===''" itemprop="name">{{item.TITLE}}</span>-->
<!--              <a v-else-if="item.LINK" :href="item.LINK" :title="item.TITLE" itemprop="item">{{item.TITLE}}</a>-->
<!--              <meta itemprop="position" :content="(i+1)">-->
<!--            </li>-->
<!--          </ul>-->
          <ul>
            <li v-for="(item, i) in breadcrumbList">
              <span v-if="item.TITLE==='/'">{{item.TITLE}}</span>
              <span v-if="item.TITLE!=='/'&&item.LINK===''">{{item.TITLE}}</span>
              <a v-else-if="item.LINK" :href="item.LINK" :title="item.TITLE">{{item.TITLE}}</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {mapState} from 'vuex';
export default {
  name: "breadcrumb",
  selector: '.breadcrumb',
  data() {
    return {}
  },
  computed:{
    ...mapState({
      breadcrumb: ({breadcrumb}) => breadcrumb?.data,
    }),
    breadcrumbList() {
      let res = [];
      for(let b in this.breadcrumb) {
        res.push(this.breadcrumb[b]);
        if(this.breadcrumb[b].LINK) {
          res.push({TITLE:"/"});
        }
      }
      return res;
    }
  }
}
</script>
<style lang="scss" scoped>
    .breadcrumb {
        // перенес в templates/main/css/fix.css потому что какая то либа перебивает стили которые прописаны здесь и добавляет при загрузке цвет фона
        /*background: none;*/
        padding: 20px 0;
    }
@media (max-width: 768px) {
  .broad-in {
    margin-top: 10px;
  }
}
</style>